// extracted by mini-css-extract-plugin
export default {"popup":"ZrJgR","container":"sO1zo","iconClose":"KUi83","wrapperImage":"E4eQZ","img":"_AFwP","iconPlay":"fKSCt","content":"AZHaW","title":"Lfr3g","text":"bdKJI"};